import t from "./ghl-ui.es1250.js";
import o from "./ghl-ui.es1248.js";
import r from "./ghl-ui.es787.js";
function f(e) {
  return t(e, r, o);
}
export {
  f as default
};
